import { SonoraViewState } from 'owa-editor-sonora-types';
import { mutatorAction } from 'satcheljs';
import AugLoopViewState from '../store/schema/AugLoopViewState';

export default mutatorAction(
    'setSonoraViewState',
    (viewState: AugLoopViewState, sonoraViewState: SonoraViewState) => {
        if (sonoraViewState) {
            viewState.sonoraViewState = sonoraViewState;
        }
    }
);
